<pm-dialog
  dialogTitle="RESULT.VISIBILITY_OPTIONS.TITLE"
  size="md"
  [primaryCtaButtonConfig]="primaryCtaButtonConfig()"
>
  <pm-fixed-y-axis-zero-point
    [(fixedYAxisZeroPoint)]="fixedYAxisZeroPoint"
    (fixedYAxisZeroPointChange)="onFixedYAxisZeroPointChange($event)"
  />
  <pm-intervals-and-confidence-level
    [(showInterval)]="showInterval"
    [(confidenceLevel)]="confidenceLevel"
    [(intervalType)]="intervalType"
    (showIntervalChange)="onShowIntervalChange($event)"
    (confidenceLevelChange)="onConfidenceLevelChange($event)"
    (intervalTypeChange)="onIntervalTypeChange($event)"
  />
</pm-dialog>
